import React from "react";

export const Logo = ({ size = 28, withText = true, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
      <rect x="0" y="0" width="32" height="32" rx="8" fill="#111216" />
      <path
        d="M5 23 V9 L11 19 L16 11 L21 19 L27 9 V23"
        stroke="url(#g)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="27" cy="9" r="1.6" fill="#76D9E8" />
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#D7B56D" />
          <stop offset="0.5" stopColor="#F5F1EA" />
          <stop offset="1" stopColor="#A9824A" />
        </linearGradient>
      </defs>
    </svg>
    {withText && (
      <div className="flex flex-col leading-none">
        <span className="font-display text-[15px] font-bold tracking-tight text-[#F5F1EA]">
          MarketEdge
        </span>
        <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-[#A9824A] mt-0.5">
          Access Lab
        </span>
      </div>
    )}
  </div>
);
